const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/tinglysing/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/tinglysing/")({
  head: () => ({
    meta: [{
      title: "Superuser tinglysing | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});